// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#container{position:fixed;height:942px;width:1250px}#container>*{position:absolute;width:100%;height:100%}", ""]);
// Exports
module.exports = exports;
